<template>
    <div style="display:flex; justify-content: center;">
        <img style="margin-top:2.5%; margin-right: 100px; height:350px;max-width:41vw;max-height:38vw;max-width:1500;max-height:1350;" src="../assets/IMGS/PNG/02_Tablet.png" alt="clouds">
            <span style="margin-top:5%; margin-bottom:5%;">

            <div v-if="statusConfirm == true" style="display: flex; justify-content: center; align-items: center; flex-flow: column;">
                <div style="background: var(--color-green);" class="headInfo">Вы успешно подтвердили почту</div>
                <p style="margin-top: 15px;">Теперь вы можете использовать 100% нашего сервиса!</p>
                <p style="font-size: 14px;">Через {{ timer }} секунд вас должно направить в профиль</p>
                <a v-if="timer <= 0" v-on:click="performAction()" style="cursor:pointer; font-size: 14px;">Перейти в профиль</a>
            </div>

            <div v-else-if="statusConfirm == false" style="display: flex; justify-content: center; align-items: center; flex-flow: column;">
                <div style="background: var(--color-red);" class="headInfo">Ошибка во время подтверждения</div>
                <p style="margin-top: 15px; margin-bottom: 15px;">По какой-то причине мы не смогли подтвердить почту!</p>
                <button v-on:click="tryConfirm()" class="ui-button ui-button--sm ui-button--secondary">Повторить</button>
            </div>
            <div v-else></div>
        </span>
    </div>
</template>

<script>
import $ from "jquery";
import { useCookies } from 'vue3-cookies';

export default {
    name: 'ConfirmEmailLink',
    el: "#confirm_email_link",
    data() {
        return {
            timer: 5,
            statusConfirm: ''
        }
    },
    created() {
        this.tryConfirm()
    },
    mounted() {
    },
    setup() {
        const { cookies } = useCookies();
        return { cookies };
    },
    methods: {
        getCookie(val) {
            return this.cookies.get(val);
        },
        tryConfirm() {
            const uuid = this.$route.params.uuid;
            const email = this.$route.params.email;
            const code = this.$route.params.code;
            var vm = this
            $.ajax({
                type: "GET",
                url: global.BACKEND_URL + `/account/confirmEmail/${uuid}/${email}/${code}`,
                success: function () {
                    if (vm.getCookie("role") == "User") {
                        document.cookie = "role=ConfirmedUser; path=/;";
                    }
                    vm.startTimer();
                    vm.statusConfirm = true
                },
                error: function () {
                    console.log("Not success :(")
                    vm.statusConfirm = false
                },
                dataType: "text",
                contentType: "application/json"
            })
        },
        startTimer() {
            const countdown = setInterval(() => {
                if (this.timer > 0) {
                    this.timer--;
                } else {
                    clearInterval(countdown);
                    this.performAction();
                }
            }, 1000);
        },
        performAction() {
            this.$router.push({ name: 'account'} );
        }
    }
};
</script>

<style scoped>
.headInfo {
    font-size: 28px;
    color: #fff;
    padding: 15px;
}
</style>
